import { render, staticRenderFns } from "./PuiIcon.vue?vue&type=template&id=e445fcba&"
import script from "./PuiIcon.vue?vue&type=script&lang=js&"
export * from "./PuiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PuiIcon.vue?vue&type=custom&index=0&blockType=description"
if (typeof block0 === 'function') block0(component)
import block1 from "./PuiIcon.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && typeof component !== 'undefined' && window.Vue) {
      window.Vue.component('PuiIcon', component.exports)
    } export default component.exports